import {React,useEffect} from 'react';
import $ from "jquery";

import './Bullet.scss';

const Bullet = props => {
    const BulletClass = [
        'Bullet', 
        props.score === 100 ? "Bullet--1" : 'Bullet--2',
    ];
    const AltText = [
        props.score === 100 ?'On track': "Opportunity for improvement" ,
    ];
    useEffect(() => {
        $('a:not([href])').each(function() { 
            $(this).remove();
        });
    });
    return (
        <li className={BulletClass.join(' ')}>
            <div className="Bullet__header">
                <div className="Bullet__radio Bullet__radio--1"></div>
                <h3 className="Bullet__title">{props.title}<span className="sr-only">{AltText}</span></h3>
            </div>
            <div className="Bullet__copy">
                <div className="Bullet__copy--main">
                    {props.mainN}
                </div>
                <a id={props.linkID} href={props.subNLink} target="_blank" rel='noreferrer' className="Bullet__copy--sub">
                    <span>{props.subNLinkText}</span><span className="sr-only">(opens in new window)</span>
                </a>
                <a id={props.linkID+"-2"} href={props.subNLink2} target="_blank" rel='noreferrer' className="Bullet__copy--sub">
                    <span>{props.subNLinkText2}</span><span className="sr-only">(opens in new window)</span>
                </a>
                <a id={props.linkID+"-3"} href={props.subNLink3} target="_blank" rel='noreferrer' className="Bullet__copy--sub">
                    <span>{props.subNLinkText3}</span><span className="sr-only">(opens in new window)</span>
                </a>
            </div>
        </li>
    )
}

export default Bullet;